module.exports = __webpack_public_path__ + "static/media/apex.da9664ca.jpg";